import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getEpisodeTypes = (params: any = {}) => {
  let query = new URLSearchParams();
  for (let key in params) {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      query.set(key, params[key]);
    }
  }
  const queryString = query.toString();
  const url = `${BASE_URL}/api/v1/episode-types${queryString ? `?${queryString}` : ""}`;
  return api.get(url);
};

export const getEpisodeType = (id: number) => {
  return api.get(`${BASE_URL}/api/v1/episode-types/${id}`);
};

export const saveEpisodeType = (payload: any) => {
  return api.post(`${BASE_URL}/api/v1/episode-types`, camelToSnake(payload));
};

export const updateEpisodeType = (payload: any) => {
  return api.put(`${BASE_URL}/api/v1/episode-types/${payload.id}`, camelToSnake(payload));
};
